import { render } from "./PseudoSkeleton.vue?vue&type=template&id=f2835c08&scoped=true"
import script from "./PseudoSkeleton.vue?vue&type=script&lang=js"
export * from "./PseudoSkeleton.vue?vue&type=script&lang=js"

import "./PseudoSkeleton.vue?vue&type=style&index=0&id=f2835c08&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2835c08"]])

export default __exports__